// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_f7-0";
export var headerCellHover = "_f7-1";
export var readCellContainer = "_f7-2";
export var unreadIndicator = "_f7-3";